<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="已上架" name="sell">
          <span slot="label">已上架 <el-tag size="mini">{{service_count.sell}}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="已下架" name="lower">
          <span slot="label">已下架 <el-tag size="mini">{{service_count.lower}}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="平台禁用" name="forbidden">
          <span slot="label">平台禁用 <el-tag size="mini">{{service_count.forbidden}}</el-tag></span>
        </el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
<!--        <el-form-item label="服务分类">-->
<!--          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">-->
<!--            <el-option label="全部" value="0"></el-option>-->
<!--            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="服务名称"><el-input size="small" v-model="searchForm.name" placeholder="请输入服务名称"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/service/service/add'">添加服务</el-button></div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="服务" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.name }}</div>
                  <div class="price">${{ scope.row.price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column prop="category.name" label="分类"></el-table-column>-->
          <el-table-column prop="hour" label="服务时长小时"></el-table-column>
          <el-table-column prop="minute" label="服务时长分钟"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope" v-if="supplier.status==0">
              <div class="table-btn-column">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/service/service/edit'">编辑服务</el-button>
                <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/service/service/delete'">删除服务</el-button>
                <el-button v-if="activeName == 'sell'" @click="changeStatus(scope.row, 2)" type="text" size="small" v-auth="'/service/service/state'">立即下架</el-button>
                <el-button v-if="activeName == 'lower'" @click="changeStatus(scope.row, 1)" type="text" size="small" v-auth="'/service/service/state'">立即上架</el-button>
                <el-button v-if="activeName != 'forbidden'" @click="set_technician(scope.row)" type="text" size="small">设置技师</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <el-dialog title="设置技师" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body='true'>
      <!--form表单-->
      <el-form size="small" ref="form">
        <el-checkbox-group v-model="checkTechnician">
          <el-checkbox
            v-for="item in options"
            :key="item.id"
            :label="item.id"
          >
            {{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSetTechnician" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ServiceApi from '@/api/service.js';
export default {
  components: {},
  data() {
    return {
      temp: {},
      checkTechnician: [],
      options: [],
      dialogVisible: false,
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        name: '',
        category_id: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      supplier:[],
      /*统计数据*/
      service_count: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    // 设置技师
    set_technician(item){
      this.checkTechnician = [];
      this.temp = item;
      let self = this;
      this.dialogVisible = true;
      ServiceApi.getServiceTechnician({
        service_id: this.temp.id,
      }).then(data => {
        self.options = data.data.technician_list;
        self.checkTechnician = data.data.technician_id_arr;
      });
    },
    handleSetTechnician() {
      let self = this;
      ServiceApi.setTechnician({
        service_id: this.temp.id,
        checkTechnician: this.checkTechnician
      }).then(data => {
        this.dialogVisible = false;
        self.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      ServiceApi.servicelist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.category;
          self.totalDataNumber = data.data.list.total;
          self.supplier = data.data.supplier;
          self.service_count = data.data.service_count;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/service/service/add');
    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/service/service/edit',
        query: {
          id: row.id,
          scene: 'edit'
        }
      });
    },

    /*删除*/
    delClick: function(row) {
      let self = this;
      let msg = '确认删除吗？';
      self.$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          ServiceApi.delService({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },

    /*修改状态*/
    changeStatus(item,value){
      let self = this;
      let msg = '';
      if(value == 1){
        msg = '确认要上架该服务吗?';
      }else{
        msg = '确认要下架该服务吗?';
      }
      self.$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          ServiceApi.changeStatus({
            id: item.id,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/service/service/index.vue